export default {
	dataDisclaimer: 'Data based on vehicles sold on the Motorway platform in the previous 12 months.',
	dataUpdatedDaily: 'Data updated daily',
	dateLastUpdated: 'Data last updated {date}',
};
